<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="25.47" height="9.535" viewBox="0 0 25.47 9.535">
		<g id="Group_32237" data-name="Group 32237" transform="translate(-1637.32 -254.232)">
			<g
				id="Rectangle_9372"
				data-name="Rectangle 9372"
				transform="translate(1651.999 254.232)"
				fill="#5a677d"
				stroke="#5a677d"
				stroke-width="1"
			>
				<rect width="10.791" height="9.535" rx="2" stroke="none" />
				<rect x="0.5" y="0.5" width="9.791" height="8.535" rx="1.5" fill="none" />
			</g>
			<g id="Group_32235" data-name="Group 32235" transform="translate(1637.972 255.528)">
				<g id="Group_30150" data-name="Group 30150" transform="translate(0 0)">
					<g id="b" transform="translate(0 0)">
						<g id="c">
							<g id="Group_29576" data-name="Group 29576">
								<path
									id="d"
									d="M8.717,1.523a1.043,1.043,0,0,1,0-.184A.928.928,0,0,0,7.723.49H5.75V7.252H7.372"
									transform="translate(-2.788 -0.485)"
									fill="none"
									stroke="#5a677d"
									stroke-linecap="round"
									stroke-miterlimit="10"
									stroke-width="1.2"
								/>
								<path
									id="e"
									d="M1.821,7.248H3.443V.481H1.475a.931.931,0,0,0-.995.849,1.043,1.043,0,0,1,0,.184"
									transform="translate(-0.481 -0.481)"
									fill="none"
									stroke="#5a677d"
									stroke-linecap="round"
									stroke-miterlimit="10"
									stroke-width="1.2"
								/>
							</g>
						</g>
					</g>
				</g>
			</g>
			<g id="Group_32236" data-name="Group 32236">
				<g id="Group_32234" data-name="Group 32234" transform="translate(1648.19 261.288) rotate(-135)">
					<line
						id="Line_839"
						data-name="Line 839"
						y1="3.34"
						transform="translate(0)"
						fill="none"
						stroke="#5a677d"
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="1.1"
					/>
					<g id="Group_32158" data-name="Group 32158" transform="translate(0 3.341)">
						<line
							id="Line_840"
							data-name="Line 840"
							x2="3.34"
							transform="translate(0 0)"
							fill="none"
							stroke="#5a677d"
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="1.1"
						/>
					</g>
				</g>
				<line
					id="Line_907"
					data-name="Line 907"
					x2="5.435"
					transform="translate(1645.065 259.012)"
					fill="none"
					stroke="#5a677d"
					stroke-linecap="round"
					stroke-width="1"
				/>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'ExportTextToParamSvg',
};
</script>

<style scoped lang="scss"></style>
